module.exports = [
	{
		"name": "All Items",
		"url": "/category/all",
		"children": [
			{
				"name": "Popular Files",
				"url": "/page/top_sellers"
			},
			{
				"name": "Featured Files",
				"url": "/feature"
			},
			{
				"name": "Top New Files",
				"url": "/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"
			},
			{
				"name": "Follow Feed",
				"url": "/follow_feed"
			},
			{
				"name": "Top Authors",
				"url": "/authors/top"
			},
			{
				"name": "Top New Authors",
				"url": "/page/top_new_sellers"
			},
			{
				"name": "Public Collections",
				"url": "/collections"
			},
			{
				"name": "View All Categories",
				"url": "/category"
			}
		]
	},
	{
		"name": "After Effects Project Files",
		"url": "/category/after-effects-project-files",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=after-effects-project-files",
				"isTop": true
			},
			{
				"name": "Broadcast Packages",
				"url": "/category/after-effects-project-files/broadcast-packages"
			},
			{
				"name": "Element 3D",
				"url": "/attributes/video-project-requires/Element 3D?sort=date"
			},
			{
				"name": "Elements",
				"url": "/category/after-effects-project-files/elements"
			},
			{
				"name": "Infographics",
				"url": "/category/after-effects-project-files/infographics"
			},
			{
				"name": "Logo Stings",
				"url": "/category/after-effects-project-files/logo-stings"
			},
			{
				"name": "Openers",
				"url": "/category/after-effects-project-files/openers"
			},
			{
				"name": "Product Promo",
				"url": "/category/after-effects-project-files/product-promo"
			},
			{
				"name": "Titles",
				"url": "/category/after-effects-project-files/titles"
			},
			{
				"name": "Video Displays",
				"url": "/category/after-effects-project-files/video-displays"
			}
		]
	},
	{
		"name": "Apple Motion",
		"url": "/category/apple-motion-templates",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=apple-motion-templates",
				"isTop": true
			},
			{
				"name": "Elements",
				"url": "/category/apple-motion-templates/elements"
			},
			{
				"name": "Logo Stings",
				"url": "/category/apple-motion-templates/logo-stings"
			},
			{
				"name": "Openers",
				"url": "/category/apple-motion-templates/openers"
			},
			{
				"name": "Titles",
				"url": "/category/apple-motion-templates/titles"
			},
			{
				"name": "Video Displays",
				"url": "/category/apple-motion-templates/video-displays"
			}
		]
	},
	{
		"name": "Motion Graphics",
		"url": "/category/motion-graphics",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=motion-graphics",
				"isTop": true
			},
			{
				"name": "Backgrounds",
				"url": "/category/motion-graphics/backgrounds"
			},
			{
				"name": "Bugs",
				"url": "/category/motion-graphics/bugs"
			},
			{
				"name": "Elements",
				"url": "/category/motion-graphics/elements"
			},
			{
				"name": "Infographics",
				"url": "/category/motion-graphics/infographics"
			},
			{
				"name": "Interface Effects",
				"url": "/category/motion-graphics/interface-effects"
			},
			{
				"name": "Lower Thirds",
				"url": "/category/motion-graphics/lower-thirds"
			},
			{
				"name": "Overlays",
				"url": "/category/motion-graphics/overlays"
			},
			{
				"name": "Revealer",
				"url": "/category/motion-graphics/revealer"
			},
			{
				"name": "Transitions",
				"url": "/category/motion-graphics/transitions"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/motion-graphics/miscellaneous"
			}
		]
	},
	{
		"name": "Stock Footage",
		"url": "/category/stock-footage",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=stock-footage",
				"isTop": true
			},
			{
				"name": "Buildings",
				"url": "/category/stock-footage/buildings"
			},
			{
				"name": "Business, Corporate",
				"url": "/category/stock-footage/business-corporate"
			},
			{
				"name": "Cartoons",
				"url": "/category/stock-footage/cartoons"
			},
			{
				"name": "City",
				"url": "/category/stock-footage/city"
			},
			{
				"name": "Construction",
				"url": "/category/stock-footage/construction"
			},
			{
				"name": "Education",
				"url": "/category/stock-footage/education"
			},
			{
				"name": "Food",
				"url": "/category/stock-footage/food"
			},
			{
				"name": "Holidays",
				"url": "/category/stock-footage/holidays"
			},
			{
				"name": "Industrial",
				"url": "/category/stock-footage/industrial"
			},
			{
				"name": "Kids",
				"url": "/category/stock-footage/kids"
			},
			{
				"name": "Lifestyle",
				"url": "/category/stock-footage/lifestyle"
			},
			{
				"name": "Medical",
				"url": "/category/stock-footage/medical"
			},
			{
				"name": "Military",
				"url": "/category/stock-footage/military"
			},
			{
				"name": "Nature",
				"url": "/category/stock-footage/nature"
			},
			{
				"name": "Overhead",
				"url": "/category/stock-footage/overhead"
			},
			{
				"name": "People",
				"url": "/category/stock-footage/people"
			},
			{
				"name": "Religious",
				"url": "/category/stock-footage/religious"
			},
			{
				"name": "Science",
				"url": "/category/stock-footage/science"
			},
			{
				"name": "Slow Motion",
				"url": "/category/stock-footage/slow-motion"
			},
			{
				"name": "Special Events",
				"url": "/category/stock-footage/special-events"
			},
			{
				"name": "Sports",
				"url": "/category/stock-footage/sports"
			},
			{
				"name": "Stop Motion",
				"url": "/category/stock-footage/stop-motion"
			},
			{
				"name": "Technology",
				"url": "/category/stock-footage/technology"
			},
			{
				"name": "Time Lapse",
				"url": "/category/stock-footage/time-lapse"
			},
			{
				"name": "Vehicles",
				"url": "/category/stock-footage/vehicles"
			},
			{
				"name": "Weather",
				"url": "/category/stock-footage/weather"
			}
		]
	},
	{
		"name": "Cinema 4D Templates",
		"url": "/category/cinema-4d-templates",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=cinema-4d-templates",
				"isTop": true
			},
			{
				"name": "Elements",
				"url": "/category/cinema-4d-templates/elements"
			},
			{
				"name": "Logo Stings",
				"url": "/category/cinema-4d-templates/logo-stings"
			},
			{
				"name": "Openers",
				"url": "/category/cinema-4d-templates/openers"
			},
			{
				"name": "Titles",
				"url": "/category/cinema-4d-templates/titles"
			},
			{
				"name": "Video Displays",
				"url": "/category/cinema-4d-templates/video-displays"
			}
		]
	},
	{
		"name": "Add Ons",
		"url": "/category/add-ons",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=add-ons",
				"isTop": true
			},
			{
				"name": "After Effects Presets",
				"url": "/category/add-ons/after-effects-presets"
			},
			{
				"name": "After Effects Scripts",
				"url": "/category/add-ons/after-effects-scripts"
			}
		]
	},
	{
		"name": "More",
		"url": "/category",
		"children": [
			{
				"name": "Logo Files",
				"url": "/search?term=logo"
			},
			{
				"name": "News Files",
				"url": "/search?term=news"
			},
			{
				"name": "Wedding Files",
				"url": "/search?term=wedding"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./config/sites/menus/videohive.json
// module id = 484
// module chunks = 1